// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RXNar","left":"styles_left__lnveH","desktopActions":"styles_desktopActions__18aEh","title":"styles_title__2eu26"};